import { useNavigate } from "react-router-dom";
import { parseChatMessage } from "../../util/ChatMessageParser";
import type { ChatMention } from "../../types/domain";

interface ChatMessageBodyProps {
  content: string;
  mentions?: ChatMention[];
}

function ChatMessageBody({ content, mentions = [] }: ChatMessageBodyProps) {
  const navigate = useNavigate();
  const segments = parseChatMessage(content, mentions);

  return (
    <>
      {segments.map((seg, i) => {
        if (seg.type === "text") {
          return <span key={i}>{seg.value}</span>;
        }
        if (seg.type === "image") {
          return (
            <a
              key={i}
              href={seg.url}
              target="_blank"
              rel="noopener noreferrer"
              className="chat-image-link"
            >
              <img
                src={seg.url}
                alt=""
                loading="lazy"
                referrerPolicy="no-referrer"
                className="chat-image"
              />
            </a>
          );
        }
        if (seg.type === "mention") {
          return (
            <span
              key={i}
              className="chat-mention"
              role="button"
              onClick={() => navigate(`/players/${seg.playerId}`)}
            >
              @{seg.name}
            </span>
          );
        }
        if (seg.type === "route-link") {
          return (
            <a
              key={i}
              className="chat-link"
              href={seg.path}
              onClick={(e) => {
                e.preventDefault();
                navigate(seg.path);
              }}
            >
              {seg.text}
            </a>
          );
        }
        return (
          <a
            key={i}
            href={seg.url}
            target="_blank"
            rel="noopener noreferrer"
            referrerPolicy="no-referrer"
            className="chat-link"
          >
            {seg.url}
          </a>
        );
      })}
    </>
  );
}

export default ChatMessageBody;
